
const mutations = {
  _SAVE_DOCUMENT_REPO_HISTORY: 'SAVE_DOCUMENT_REPO_HISTORY',
  _SAVE_DOCUMENT_REPO_COMMIT_COMPONENTS: 'SAVE_DOCUMENT_REPO_COMMIT_COMPONENTS',
  _SAVE_SELECTED_COMPONENT_INDEX: 'SAVE_SELECTED_COMPONENT_INDEX',
  _SAVE_PREV_CURR_NEXT_PARAGRAPHS: 'SAVE_PREV_CURR_NEXT_PARAGRAPHS',
};

export default {
  mutations,
};
